var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"layout-section"},[_c('h2',{staticClass:"layout-section__title"},[_vm._v("Quelques projets dont nous sommes fiers")])])}]

export { render, staticRenderFns }